// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"postItem-module--wrapper--3WEQb","image":"postItem-module--image--3rE7J","title":"postItem-module--title--1c3vR"};